<div class="input-group mb-3 mt-1 custom-file-button">
  @if (!readonly) {
    <input
      (change)="onFileChange($event)"
      accept=".csv"
      class="form-control"
      id="inputGrundstueckFile"
      placeholder="DateiMitGrundstückidentifikatoren"
      type="file" />
  }
  @if (readonly) {
    <input [(ngModel)]="fileName" class="form-control" disabled id="DateiMitGrundstückidentifikatoren" type="text" />
  }
  <label class="input-group-text" for="inputGrundstueckFile">{{ "configuration.fileAuswaehlen" | translate }}</label>
</div>
